module.exports = __webpack_public_path__ + "static/fonts/OpenSans-LightItalic.8424d63.eot";


//////////////////
// WEBPACK FOOTER
// ./static/font/OpenSans-LightItalic.eot
// module id = Gqsd
// module chunks = 3